import React, { FC, HTMLAttributes } from 'react';

export interface DateContainerProps extends HTMLAttributes<HTMLDivElement> {
  range: string;
}

export const DateContainer: FC<DateContainerProps> = ({
  range,
  className,
  ...rest
}: DateContainerProps) => {
  const currentDate = new Date();
  const pastDate = new Date(currentDate);

  if (range === 'Last 90 Days') {
    // rangeNumber = 90;
    pastDate.setDate(pastDate.getDate() - 90);
  }
  if (range === 'Last 60 Days') {
    // rangeNumber = 60;
    pastDate.setDate(pastDate.getDate() - 60);
  }
  if (range === 'Last 30 Days') {
    // rangeNumber = 30;
    pastDate.setDate(pastDate.getDate() - 30);
  }
  if (range === 'Last 6 Months') {
    // rangeNumber = 180;
    pastDate.setMonth(pastDate.getMonth() - 6);
  }
  if (range === 'Last Year') {
    // rangeNumber = 365;
    pastDate.setFullYear(pastDate.getFullYear() - 1);
  }

  return (
    <div
      className={`text-thryv-black-500 font-semibold text-[14px] font-open-sans ${
        className || ''
      }`}
      {...rest}
    >
      {pastDate.toLocaleDateString()} - {currentDate.toLocaleDateString()}
    </div>
  );
};
